import { Stack, Typography } from "@mui/material";
import { compact } from "lodash-es";
import React from "react";

import { SENSITIVE_BY_CLASS_NAME } from "../../utils/highlightUtils";
import { IAddressDisplayFieldsFragment } from "./AddressDisplay.generated";

interface IProps {
    inline?: boolean;
    address: IAddressDisplayFieldsFragment;
}

export const AddressDisplay: React.FC<IProps> = ({
    inline,
    address: { street, street2, city, state, postalCode, countryCode },
}) => {
    function renderLine(line: string, index?: number) {
        return (
            <Typography key={index} variant="inherit" component="span">
                {line}
            </Typography>
        );
    }

    const lines = [
        compact([street, street2]).join(", "),
        compact([city, compact([state, postalCode]).join(" ")]).join(", "),
        countryCode,
    ];

    if (inline) {
        return (
            <Typography component="span" variant="inherit" {...SENSITIVE_BY_CLASS_NAME}>
                {lines.join(", ")}
            </Typography>
        );
    }

    return <Stack {...SENSITIVE_BY_CLASS_NAME}>{lines.map(renderLine)}</Stack>;
};
